<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  dialogTitle="Import Resource"
  [form]="form"
  submitLabel="Import"
  [submitDisabled]="!form.valid"
  (cancel)="cancel()"
  (submit)="import()"
>
  <div crucibleDialogContent [formGroup]="form">
    <div class="import-resource-fields">
      <mat-form-field floatLabel="always">
        <mat-label>Address</mat-label>
        <input
          matInput
          formControlName="address"
          matTooltip="Address of the Resource to import"
          cdkFocusInitial
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>Id</mat-label>
        <input
          matInput
          formControlName="id"
          matTooltip="Id of the Resource to import. The format of this field is Resource specific."
        />
      </mat-form-field>

      <div class="output" matTooltip="Results of the import command">
        <cas-output [loading]="false" [output]="message"></cas-output>
      </div>
    </div>
  </div>
</crucible-dialog>
